import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hoursMinutes',
    pure: false
})
export class HoursMinutesPipe implements PipeTransform {

    transform(value: number): string {
        const minutes = value % 60;
        const hours = (value - minutes) / 60;
        const hour = 'hour:';
        const minutesStr = 'minutes';
        const HoursMinutes = (hours < 0 ? hours.toString() + hour : '') + (minutes < 10 ? '0' : '') + minutes.toString() + minutesStr;
        return HoursMinutes;

    }
}
